var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoubleSquareFrenchCuff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5142 53.6047C15.961 41.1254 9.72161 30.1241 4.63088 37.8415C1.34718 44.7379 11.3634 50.4849 23.5142 53.6047Z",
    stroke: "#757575",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5131 53.6023L38.948 38.1674C29.7528 29.1364 26.3046 19.6127 19.5723 22.2399L5.28687 36.8538C9.88448 30.6142 17.4377 42.765 23.5131 53.6023Z",
    stroke: "#757575",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4089 22.2411L33.5302 5",
    stroke: "#757575",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7842 38.0057L55.8611 21.4214",
    stroke: "#757575",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4705 36.8556C41.3283 31.4131 43.6229 28.7237 47.8151 24.2122C44.3096 29.8761 42.2465 32.864 38.1273 37.3482",
    stroke: "#757575",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3644 44.9008L21.3792 45.886L23.5138 47.528L25.32 45.7218L23.1854 44.0798L22.3644 44.9008ZM22.3644 44.9008L21.0508 43.5872",
    stroke: "#757575",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4988 46.7073L25.6482 47.8567",
    stroke: "#757575",
    strokeWidth: 1.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0068 22.2418C24.928 20.2537 26.3056 18.6294 28.4403 17.48",
    stroke: "#757575",
    strokeWidth: 1.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6646 34.7215C37.8424 33.2274 38.8237 32.1934 40.098 29.9597",
    stroke: "#757575",
    strokeWidth: 1.5
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8831 53.2763L26.0208 55.0765L40.8206 39.98L39.3478 38.1389",
    stroke: "#757575",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleSquareFrenchCuff);
export default __webpack_public_path__ + "static/media/double_square_french_cuff.372ab5149292e62c079c68f8ba6cb574.svg";
export { ForwardRef as ReactComponent };